import React, { useEffect, useRef } from 'react';

const ScrollAnimation = ({ children, className = '', threshold = 0.1, delay = 0 }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const currentRef = elementRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, delay);
          }
        });
      },
      { threshold }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, delay]);

  return (
    <div ref={elementRef} className={`scroll-animation ${className}`}>
      {children}
    </div>
  );
};

export default ScrollAnimation; 